import { render } from "./PageBanner.vue?vue&type=template&id=b2c64e5a&scoped=true&ts=true"
import script from "./PageBanner.vue?vue&type=script&lang=ts"
export * from "./PageBanner.vue?vue&type=script&lang=ts"

import "./PageBanner.vue?vue&type=style&index=0&id=b2c64e5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c64e5a"]])

export default __exports__